import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';

import Link from '@nerdwallet/react-link';
import Type from '@nerdwallet/react-typography';

import Back from '@nerdwallet/react-icon/nerdwallet-ui/Back';
import { MonetizingLink as MonetizingLinkType } from '~/config/resource-article';

import style from './monetizing-link.module.less';

interface Props {
  monetizingLinkData: MonetizingLinkType;
}

const MonetizingLink: React.FC<Props> = ({ monetizingLinkData }) => {
  if (!monetizingLinkData) {
    return null;
  }

  return (
    <Link
      href={`${monetizingLinkData.url}?trk=nw_ra_action_link`}
      unstyled
      className={classNames([
        'outset',
        classes([
          'display-block',
          'background-green',
          'position-relative',
          'margin-vertical-0--wide',
          'padding-all-3',
          'border-radius-1--wide',
          'border-bottom-1',
          'border-top-1',
          'border-neutral-lighter',
          'border-all-0--wide',
          'gotham',
        ]),
      ])}
    >
      {monetizingLinkData.action && (
        <Type
          uppercase
          size={1}
          color="neutral-lightest"
          className={classes(['font-weight-normal', 'padding-left-3--wide'])}
        >
          {monetizingLinkData.action}
        </Type>
      )}
      <Type
        color="neutral-lightest"
        className={classNames([
          style.linkText,
          classes(['padding-left-3--wide', 'padding-right-4']),
        ])}
      >
        {monetizingLinkData.text}
      </Type>
      <Back
        className={classNames([
          style.icon,
          classes(['position-absolute', 'color-neutral-lightest']),
        ])}
      />
    </Link>
  );
};

MonetizingLink.displayName = 'MonetizingLink';

export default MonetizingLink;
